import { useEffect, useState } from 'react';

/**
 * 返回 `value` 的「停手后才更新」版本，用来把「每敲一个字发一次请求」压成一次。
 *
 * 首帧直接取当前值而不是等满 `delayMs`：否则开页时先按空值发一轮、停手后再按真值发一轮，
 * 反而多出一条请求。同理，值被改回当前防抖值（打字后又删干净）时不起定时器，也就不会多发。
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (value === debounced) return;
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, debounced, delayMs]);

  return debounced;
}
